// src/components/PublicKnowledgeBase.jsx
// Public wrapper around KnowledgeBase — no login required
import { useNavigate } from 'react-router-dom';
import KnowledgeBase from './dashboard/KnowledgeBase';

const SERIF = "'Georgia', serif";
const SANS  = "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export default function PublicKnowledgeBase() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F7F6F3', fontFamily: SANS }}>
      <nav style={{ backgroundColor: '#122326', padding: '14px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontFamily: SERIF, fontSize: 18, fontWeight: 700, color: '#F0EFEB' }}>PADD CDBG Hub</span>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <button
            onClick={() => navigate('/funding-finder')}
            style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#F0EFEB', padding: '6px 16px', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}
          >
            🎯 Funding Finder
          </button>
          <button
            onClick={() => navigate('/')}
            style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#F0EFEB', padding: '6px 16px', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}
          >
            ← Back to Home
          </button>
        </div>
      </nav>
      <KnowledgeBase />
    </div>
  );
}
